import DashboardLayout from '../layout/Dashboard';
import { AuthGuard } from './RouteGuards';
import Candidates from './dashboardRoutes/CandidateRoutes';
import Jobs from './dashboardRoutes/JobsRoutes';
import Contacts from './dashboardRoutes/ContactRoutes';
import Company from './dashboardRoutes/CompanyRoutes';
import Teams from './dashboardRoutes/TeamsRoutes';
import Tasks from './dashboardRoutes/TaskManagerRoutes';
import Common from './dashboardRoutes/CommonRoutes';
import Onboarding from './dashboardRoutes/OnboardingRoutes';
import Users from './dashboardRoutes/UserRoutes';

const DashboardRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <DashboardLayout />
        </AuthGuard>
    ),
    children: [...Candidates, ...Jobs, ...Contacts, ...Company, ...Teams, ...Tasks, ...Onboarding, ...Common, ...Users]
};

export default DashboardRoutes;
